import React from 'react';
import {Link, useHistory} from 'react-router-dom';
import {Grid, Menu} from 'antd';
import IntlMessage from '../util-components/IntlMessage';
import Icon from '../util-components/Icon';
import navigationConfig from 'configs/NavigationConfig';
import {connect} from 'react-redux';
import {SIDE_NAV_LIGHT} from 'constants/ThemeConstant';
import {onMobileNavToggle} from 'redux/actions/Theme';
import Utils from 'utils';

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key, history) => {
  let keyList = [];
  let keyString = '';
  if (key) {
    const arr = key.split('-');
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  } else if (history) {
    const path = history.location.pathname;
    const parts = path.split('/');
    if (parts.length >= 3) {
      keyList.push(parts[2]);
    }
  }
  return keyList;
};

const DocumentationSideNavContent = (props) => {
  const history = useHistory();
  const {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    onMobileNavToggle,
  } = props;
  const isMobile = !Utils.getBreakPoint(useBreakpoint()).includes('lg');
  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };

  return (
    <>
      <Menu
        theme={sideNavTheme === SIDE_NAV_LIGHT ? 'light' : 'dark'}
        mode="inline"
        style={{ height: '100vh', borderRight: 0 }}
        defaultSelectedKeys={[...setDefaultOpen(routeInfo?.key, history)]}
        defaultOpenKeys={setDefaultOpen(routeInfo?.key, history)}
        selectedKeys={[...setDefaultOpen(routeInfo?.key, history)]}
        className={`d-flex flex-column ${
          hideGroupTitle ? 'hide-group-title' : ''
        } ${isMobile ? 'mobile-nav-menu' : ''}`}
      >
        {navigationConfig.map((menu) =>
          menu.submenu.length > 0 ? (
            <Menu.ItemGroup
              key={menu.key}
              title={setLocale(localization, menu.title)}
            >
              {menu.submenu.map((subMenuFirst) =>
                subMenuFirst.submenu.length > 0 ? (
                  <SubMenu
                    icon={
                      subMenuFirst.icon ? (
                        <Icon type={subMenuFirst?.icon} />
                      ) : null
                    }
                    key={subMenuFirst.key}
                    title={setLocale(localization, subMenuFirst.title)}
                  >
                    {subMenuFirst.submenu.map((subMenuSecond) => (
                      <Menu.Item key={subMenuSecond.key}>
                        {subMenuSecond.icon ? (
                          <Icon type={subMenuSecond?.icon} />
                        ) : null}
                        <span>
                          {setLocale(localization, subMenuSecond.title)}
                        </span>
                        <Link
                          onClick={() => closeMobileNav()}
                          to={subMenuSecond.path}
                        />
                      </Menu.Item>
                    ))}
                  </SubMenu>
                ) : (
                  <Menu.Item key={subMenuFirst.key} icon={subMenuFirst.icon}>
                    <span>{setLocale(localization, subMenuFirst.title)}</span>
                    <Link
                      onClick={() => closeMobileNav()}
                      to={subMenuFirst.path}
                    />
                  </Menu.Item>
                )
              )}
            </Menu.ItemGroup>
          ) : (
            <Menu.Item
              className="nav-item-styling"
              key={menu.key}
              icon={<menu.Icon />}
            >
              <span>
                {menu.path ? (
                  <Link
                    id={menu.key + '-left-navigation-item'}
                    onClick={() => closeMobileNav()}
                    to={menu.path}
                    className="nav-link-styling"
                  >
                    {setLocale(localization, menu?.title)}
                  </Link>
                ) : null}
              </span>
            </Menu.Item>
          )
        )}

        <div className="flex-fill" />
      </Menu>
    </>
  );
};

const mapStateToProps = ({ theme }) => {
  const { sideNavTheme, topNavColor } = theme;
  return { sideNavTheme, topNavColor };
};

export default connect(mapStateToProps, { onMobileNavToggle })(
  DocumentationSideNavContent
);
